import queryString from 'query-string'
import { usingGet, usingPost, usingPut, usingDelete } from '@ocean/api'
import {
  SchedulesTagFilterItems,
  ShowType,
  ListScheduleSessionsModel,
  AddSimulatorTrainingScheduleModel,
  UpdateSimulatorTrainingEnrollmentsModel,
  UpdateSimulatorTrainingScheduleSessionModel,
  DemandSimulatorTrainingScheduleSessionModel,
  UpdateSimulatorTrainingScheduleSessionsRequest,
} from 'modules/simulatorTrainings/instructor/instructorLed/Schedules/types'

export const getListSimulatorTrainingSchedules = (
  filters: SchedulesTagFilterItems,
  trainingId: Guid
) => {
  const { status, showType } = filters
  const includeOthers = showType.value === ShowType.All
  const period = status.value
  const queryParams = queryString.stringify({ includeOthers, period }, { skipNull: true })
  return usingGet(`SimulatorTrainings/instructorLed/${trainingId}/schedules?${queryParams}`, {
    useProxy: true,
  })
}

export const getListScheduleMaintenanceAndSessions = (
  trainingId: Guid,
  params: ListScheduleSessionsModel
) => {
  const queryParams = queryString.stringify(params, { skipNull: true })
  return usingGet(`SimulatorTrainings/instructorLed/${trainingId}/sessions?${queryParams}`, {
    useProxy: true,
  })
}

export const addSimulatorTrainingSchedule = (params: AddSimulatorTrainingScheduleModel) =>
  usingPost('SimulatorTrainings/AddSimulatorTrainingSchedule', params)

export const demandSimulatorTrainingScheduleSession = (
  params: DemandSimulatorTrainingScheduleSessionModel
) => usingPost('SimulatorTrainings/DemandSimulatorTrainingScheduleSession', params)

export const updateSimulatorTrainingEnrollments = (
  params: UpdateSimulatorTrainingEnrollmentsModel
) => usingPost('SimulatorTrainings/UpdateSimulatorTrainingEnrollments', params)

export const updateSimulatorTrainingScheduleSessions = (
  params: UpdateSimulatorTrainingScheduleSessionsRequest
) => usingPost(`SimulatorTrainings/UpdateSimulatorTrainingScheduleSessions`, params)

export const updateSimulatorTrainingScheduleSession = (
  sessionId: Guid,
  params: UpdateSimulatorTrainingScheduleSessionModel
) =>
  usingPut(
    `SimulatorTrainings/UpdateSimulatorTrainingScheduleSession?sessionId=${sessionId}`,
    params
  )

export const deleteSimulatorTrainingScheduleSession = (sessionId: Guid) =>
  usingDelete(`SimulatorTrainings/DeleteSimulatorTrainingScheduleSession?sessionId=${sessionId}`)

export const deleteSimulatorTrainingSchedule = (scheduleId: Guid) =>
  usingDelete(`SimulatorTrainings/DeleteSimulatorTrainingSchedule?scheduleId=${scheduleId}`)

export const updateSimulatorTrainingSchedule = (scheduleId: Guid, title: string) =>
  usingPut(`SimulatorTrainings/UpdateSimulatorTrainingSchedule?scheduleId=${scheduleId}`, { title })
